let Sliders = function () {

    this.defaults = {
        arrows: false,
        dots: true,
        centerMode: false,
        infinite: true,
        vertical: false,
        verticalSwiping: false,
        swipeToSlide: true,
        edgeFriction: true,
        accessibility: true,
        slidesToScroll: 1,
        speed: 300,
        autoplaySpeed: 6000,
        autoplay: false,
        mobileFirst: true,
        accessibility: false
    };

    this.init();
};

Sliders.prototype.init = function () {
    this.home();
    this.genericHero();
    this.footer();
    this.donationMethods();
};

Sliders.prototype.home = function () {

    let homeSlider = '.home-slider';

    let opts = {
        autoplay: true,
        appendDots: $('.slide-content')
    };

    $(homeSlider)
        .slick(this.buildOptions(opts))
        .on( 'afterChange', function( event, slick, currentSlide ) {
            var $dots = $( '.slick-dots' );
            $( 'li', $dots ).removeClass( 'slick-active' );
            $dots.each( function() {
                $( 'li', $( this ) ).eq( currentSlide ).addClass( 'slick-active' );
            } );
    } );

};

Sliders.prototype.genericHero = function () {

    let homeSlider = '.generic-slider';

    let opts = {};

    $(homeSlider).slick(this.buildOptions(opts));

};

Sliders.prototype.footer = function () {

    let footerSlider = '#footer-slider';

    let opts = {
        infinite: false,
        autoplay: false,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: 'unslick'
            },
            {
                breakpoint: 1200,
                settings: 'unslick'
            }
        ]
    };

    $(footerSlider).slick(this.buildOptions(opts));

};

Sliders.prototype.donationMethods = function () {

    let donationSlider = '#donation-methods';

    let opts = {
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    };

    $(donationSlider).slick(this.buildOptions(opts));

};

Sliders.prototype.buildOptions = function (opts) {
    return $.extend({}, this.defaults, opts);
};

/**
 * Static initialiser
 */
Sliders.init = function () {
    return new Sliders();
};

export default Sliders;